var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPassengers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1200 1200",
    style: {
      enableBackground: "new 0 0 1200 1200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#222222;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M894.1,461.3c0,162.4-131.7,294.1-294.1,294.1S305.9,623.8,305.9,461.3S437.6,167.3,600,167.3 S894.1,298.9,894.1,461.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M786,725.4c-52.6,37.2-116.8,59.1-186,59.1s-133.4-21.9-186-59.1c-181,24.4-308.7,99.9-308.7,307.3h989.4 C1094.7,825.3,967,749.8,786,725.4L786,725.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassengers);
export default __webpack_public_path__ + "static/media/Passengers.e14d809996728adecc469d083f3d1466.svg";
export { ForwardRef as ReactComponent };